import styled from "styled-components";

export const ModalCancelPurchaseContents = styled.div`
	padding: 0 1em;
`;
